import { WaterSubNetworkBase } from './base/water-sub-network-base';

export class WaterSubNetwork extends WaterSubNetworkBase { }